import React, { useEffect, useState, useCallback } from "react";
import {
  FaRegChartBar,
} from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/sidenav.css";
import $ from "jquery";
import { useSidebarMenu } from "../../hooks/useSidebarMenu";
import { ChevronDown, ChevronUp, LayoutGrid, Settings, ArrowRight } from "lucide-react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import uiConfig from "../../config/uiConfig";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function SideMenu({
  name,
  pages,
  id,
  setcurrentPage,
  activeCurrentPage,
  activeIndexData,
  reportnameFetch,
  Embedaccess_token,
}) {
  const { fetchMenu, fetchUserRole } = useSidebarMenu();
  const [pathValueData, setpathValueData] = useState("");
  const [, setError] = useState(null);
  const [, setisReport] = useState(false);
  const { ReportID } = useParams();
  const [getreportPages, setReportpage] = useState(() => {
    try {
      const cached = sessionStorage.getItem("sidemenu-data");
      return cached ? JSON.parse(cached) : {};
    } catch {
      return {};
    }
  });
  const [PageAuth] = useState(true);
  const [userRole, setuserRole] = useState(() => {
    try {
      const cached = sessionStorage.getItem("sidemenu-userrole");
      return cached ? JSON.parse(cached) : undefined;
    } catch {
      return undefined;
    }
  });
  const [hide, setHide] = useState(false);
  const [reportsListOpen, setReportsListOpen] = useState(true);
  const [activeIndex, setActiveIndex] = useState(activeIndexData || 0);
  const [reportnameFetchData, setreportnameFetchData] =
    useState(reportnameFetch);

  // Toggle handler for reports list
  const toggleReportsList = useCallback(() => {
    setReportsListOpen((prev) => !prev);
  }, []);

  // Keep the highlighted page in sync once the report resolves the initial
  // active page index asynchronously (after this component has already mounted).
  useEffect(() => {
    if (activeIndexData !== undefined && activeIndexData !== null) {
      setActiveIndex(activeIndexData);
    }
  }, [activeIndexData]);

  // Skip the loading skeleton entirely when we already have cached menu data
  const [isLoading, setIsLoading] = useState(
    () => !sessionStorage.getItem("sidemenu-data")
  );

  useEffect(() => {
    if (PageAuth) {
      fetchUserRole()
        .then((userRoleData) => {
          setuserRole(userRoleData);
          sessionStorage.setItem("sidemenu-userrole", JSON.stringify(userRoleData));
        })
        .catch(() => {
          setuserRole();
        });
    }
  }, [PageAuth, fetchUserRole]);

  localStorage.setItem("userType", userRole?.userType);
  // localStorage.setItem("userGroup", userRole?.userGroup);

  const URole = userRole?.userType;

  const CACHE_KEY = "sidemenu-data";

  const fetchSearchByname = async () => {
    // Return cached menu if available — but still fetch reports in background
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        setReportpage(JSON.parse(cached));
        // Fetch fresh reports in background without showing loader again
        try {
          const menuData = await fetchMenu();
          setReportpage(menuData);
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(menuData));
        } catch (err) {
          setError(err.message);
        }
        return;
      } catch {
        sessionStorage.removeItem(CACHE_KEY);
      }
    }

    // No cache — fetch and show loading
    setIsLoading(true);
    try {
      const menuData = await fetchMenu();
      setReportpage(menuData);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(menuData));
      setError(null);
    } catch (err) {
      setError(err.message);
      setReportpage(null);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSearchByname();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUrlData = () => {
    const getURl = new URL(window.location.href);

    const pathValue = getURl.pathname;
    setpathValueData(pathValue);
    if (pathValue === "/") {
      $("#MenuItmes_Overview").addClass("active");
      $(".getInfo").css("display", "none !important");
    }
    if (pathValue === "/userRegistration") {
      $("#MenuItmes_createUsers").addClass("active");
    }
    if (pathValue === "/settings/visuals") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (pathValue === "/ReportGenerate") {
      $("#MenuItmes_ReportGenerate").addClass("active");
    }
    if (pathValue === "/settings/visuals") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (ReportID !== undefined) {
      $("#MenuItmes_Report").addClass("active");
    }
  };

  useEffect(() => {
    getUrlData();
  });


  const checkPath = () => {
    const getURl = new URL(window.location.href);
    // const Idfetch = url.searchParams.get("admClientId");
    const pathValue = getURl.pathname;

    if (
      pathValue === "/"
    ) {
      setisReport(false);
    } else {
      setisReport(true);
    }
  };

  useEffect(() => {
    checkPath();
  }, []);

  //console.log(pathValueData)
  const renderSkeleton = () => (
    <div>
      {Array(4)
        .fill()
        .map((_, i) => (
          <div key={i} style={{ marginBottom: "10px" }}>
            <Skeleton height={40} />
          </div>
        ))}
    </div>
  );

  // console.log(reportnameFetch)

  return (
    <div>
      <div id="mySidenav" className={`sideNav common_bg_color ${name}`}>
        <div className="sideNavMenu" style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
          <div className="sideNavHeaderLogo" style={{ display: "flex", justifyContent: "center", width: "100%", padding: "4px 0 12px" }}>
            <img src={uiConfig.sidebarCollapsedLogo} alt="Aays" style={{ width: "36px", height: "auto" }} />
          </div>
          <div className="sideNavExpandedLogo item_menuText" style={{ width: "100%", textAlign: "center", padding: "6px" }}>
            <img src={uiConfig.sidebarExpandedLogo} alt="Aays" style={{ maxWidth: "120px", height: "auto" }} />
          </div>
          <div className="sideNavMenu_grid" style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <div style={{ display: "grid", gridGap: "15px", justifyContent: "start", justifyItems: "start", width: "100%", alignContent: "start" }}>
              {isLoading ? (
                renderSkeleton()
              ) : (
                <>
                  <Link to={"/"}>
                    <div
                      id="MenuItmes_Overview"
                      style={{ gridGap: "1rem", justifyContent: "flex-start" }}
                      className="items_menu"
                    >
                      <div title="Overview">
                        <LayoutGrid size={28} />
                      </div>
                      <div className="item_menuText">Overview</div>
                    </div>
                  </Link>

                  <Link to={"/settings/visuals"}>
                    <div
                      id="MenuItmes_Settings"
                      style={{ gridGap: "1rem", justifyContent: "flex-start" }}
                      className="items_menu"
                    >
                      <div title="Visual Configuration">
                        <Settings size={28} />
                      </div>
                      <div className="item_menuText">Visual Configuration</div>
                    </div>
                  </Link>

                  <div
                    id="MenuItmes_Report"
                    className="items_menu item_menuText"
                    onClick={toggleReportsList}
                    style={{ cursor: "pointer", width: "100%" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gridGap: "15px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div style={{ display: "flex", gridGap: "15px", alignItems: "center" }}>
                        <div>
                          <FaRegChartBar title="Reports" fontSize={28} />
                        </div>
                        <div className="item_menuText">Reports</div>
                      </div>
                      <div className="item_menuText">
                        {reportsListOpen ? (
                          <ChevronUp size={20} />
                        ) : (
                          <ChevronDown size={20} />
                        )}
                      </div>
                    </div>
                  </div>

                  {reportsListOpen && (
                    <div id="All_reports">
                      {getreportPages?.reports?.slice(0, 4).map((items, index) => {
                        const isOpenReport = items[0] === parseInt(id) && Embedaccess_token !== null;
                        return (
                          <div
                            id={`report_${items[0]}`}
                            key={index}
                            style={{ display: "grid" }}
                            className="items_menu"
                          >
                          <div
                            style={{
                              justifyContent: "space-between",
                              width: "100%",
                              alignItems: "center",
                              position: "relative",
                              paddingRight: "28px",
                              boxSizing: "border-box"
                            }}
                            className="item-flex-report item-flex-report-row"
                          >
                            <div className="item-flex-report-name" style={{ display: "flex", alignItems: "center", gridGap: "10px" }}>
                              <Link
                                to={`/reports/${items[0]}/view?groupId=${items[6]}`}
                                className="reportLetterBoxLink"
                                style={{ textDecoration: "none", flexShrink: 0 }}
                              >
                                <span className="tooltiptext">{items[1]}</span>
                                <span
                                  className="reportLetterBox"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "32px",
                                    height: "32px",
                                    flexShrink: 0,
                                    borderRadius: "6px",
                                    background:
                                      uiConfig.sidebarReportColors?.[
                                        index % uiConfig.sidebarReportColors.length
                                      ] || "rgba(255,255,255,0.16)",
                                    color: "#FFFFFF",
                                    fontSize: "13px",
                                    fontWeight: 700,
                                  }}
                                >
                                  {(items[1] || "?").charAt(0).toUpperCase()}
                                </span>
                              </Link>
                              <div style={{ display: "block" }}>
                                <div
                                  id="reportName_id_name"
                                  className="item_menuText"
                                >
                                  <a
                                    href={`/reports/${items[0]}/view?groupId=${items[6]}`}
                                  >
                                    {items[1]}
                                  </a>
                                </div>
                              </div>
                            </div>

                            {isOpenReport ? (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                                onClick={() => setHide(!hide)}
                                style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}
                              >
                                {hide ? (
                                  <ChevronDown size={20} />
                                ) : (
                                  <ChevronUp size={20} />
                                )}
                              </div>
                            ) : (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                                style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}
                              >
                                <Link
                                  to={
                                    `/reports/${items[0]}/view?groupId=${items[6]}`
                                  }
                                >
                                  <ArrowRight size={18} />
                                </Link>
                              </div>
                            )}
                          </div>

                          {Embedaccess_token !== null && (
                            <>
                              {items[0] === parseInt(id) ? (
                                <div id="powerbi_emb_report">
                                  {!hide && (
                                    <div id="pbiPages">
                                      <div>
                                        {pages.length !== 0 ? (
                                          <>
                                            {pages &&
                                              pages.map((item, index) => {
                                                return (
                                                  <>
                                                    {item.visibility === 0 && (
                                                      <span
                                                        onClick={() => {
                                                          activeCurrentPage(index);
                                                          setActiveIndex(index);
                                                          setreportnameFetchData(
                                                            null
                                                          );
                                                        }}
                                                        style={{
                                                          cursor: "pointer",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gridGap: "8px",
                                                        }}
                                                        key={index}
                                                        className={
                                                          reportnameFetchData !==
                                                          null
                                                            ? item.isActive ===
                                                              true
                                                              ? "item_menuText mystyle active"
                                                              : "item_menuText mystyle"
                                                            : `item_menuText mystyle ${
                                                                activeIndex ===
                                                                index
                                                                  ? "active"
                                                                  : ""
                                                              }`
                                                        }
                                                      >
                                                        <span className="tooltiptext">
                                                          {item.displayName}
                                                        </span>
                                                        <DescriptionOutlinedIcon sx={{ fontSize: "15px", flexShrink: 0, opacity: 0.8 }} />
                                                        <span className="pbiPageLabel">{item.displayName}</span>
                                                      </span>
                                                    )}
                                                  </>
                                                );
                                              })}
                                          </>
                                        ) : (
                                          <>
                                            {Array(2)
                                              .fill()
                                              .map((_, i) => (
                                                <div
                                                  key={i}
                                                  style={{
                                                    marginBottom: "0px",
                                                  }}
                                                >
                                                  <Skeleton height={30} />
                                                </div>
                                              ))}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </div>
                      );
                    })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <Box sx={{ mt: "auto", px: 1.5, pb: 1.5, width: "100%" }}>
            <Divider sx={{ borderColor: "rgba(255,255,255,0.14)", mb: 1.2 }} />

            {(() => {
              const userName = localStorage.getItem("userName") || "User";
              const userEmail = localStorage.getItem("myemail") || "";
              const cleanedName = userName
                .replace(/\s*\([^)]*\)\s*$/, "")
                .replace(/,/g, " ")
                .trim();
              const nameParts = cleanedName ? cleanedName.split(/\s+/).filter(Boolean) : [];
              const firstName = nameParts[0] || "";
              const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
              const initials = lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);

              return (
                <Box className="userFooterPillRow" sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  <Tooltip title={`${userName} (${userEmail})`} placement="right" arrow>
                    <Box
                      className="userFooterPill"
                      sx={{
                        alignItems: "center",
                        gap: 1.2,
                        borderRadius: 2,
                        px: 1,
                        py: 1,
                        background: "var(--app-sidebar-highlight)",
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 34,
                          height: 34,
                          fontSize: 10,
                          background: uiConfig.tableAccentGradient,
                          color: "#FFFFFF",
                          fontWeight: 700,
                        }}
                      >
                      <span className="text-[14px]">{initials.toUpperCase()}</span>
                      </Avatar>

                      <Box className="userNameCol" sx={{ minWidth: 0 }}>
                        <Typography
                          sx={{ color: "#FFFFFF", fontSize: 13, fontWeight: 600, lineHeight: 1.2 }}
                          noWrap
                        >
                          {userName}
                        </Typography>

                        <Typography
                          sx={{ color: "#FFFFFF", fontSize: 11, lineHeight: 1.2 }}
                          noWrap
                        >
                          {userEmail}
                        </Typography>
                      </Box>
                    </Box>
                  </Tooltip>
                </Box>
              );
            })()}
          </Box>
        </div>
      </div>
    </div>
  );
}
